// Static credentials (front-end only)
export const ADMIN_CREDENTIALS = {
  id: "admin@avena.com",      // 👈 your admin ID
  password: "Avena@123",  // 👈 your admin password
};
